import React from 'react';
import clsx from 'clsx';
import {useIntl, IntlShape} from 'react-intl'
import { SupportTicket } from '../../core/_models';
import { ReplyForm } from './ReplyForm'

interface Props {
  ticket: SupportTicket;
}

const formatDate = (intl: IntlShape, date: Date) => {
  return intl.formatDate(date, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  })
}

export const TicketOverview = ({ ticket }: Props) => {
  const intl = useIntl()

  return (
    <>
      <div className="">
        <div className="d-flex justify-content-between py-2 border-bottom">
          <span className="text-muted">Ticket Type</span>
          <span>{ticket.type}</span>
        </div>

        {ticket.order && (
          <>
            <div className="d-flex justify-content-between py-2 border-bottom">
              <span className="text-muted">Product</span>
              <span>{ticket.order.product}</span>
            </div>
            <div className="d-flex justify-content-between py-2 border-bottom">
              <span className="text-muted">Order date</span>
              <span>{formatDate(intl, ticket.order.date)}</span>
            </div>
            <div className="d-flex justify-content-between py-2">
              <span className="text-muted">Voucher</span>
              <span>{ticket.order.code}</span>
            </div>
          </>
        )}

      </div>

      <div className='separator separator-dashed my-5'></div> 

      {ticket.messages.map((msg, i) => (
        <div
          key={`msg-${i}`}
          className={clsx('d-flex d-flex  mb-10 mb-10', `justify-content-${msg.support ? 'end': 'start'}`)}>
          <div className="d-flex flex-column align-items align-items-start">
            <div className="d-flex align-items-center mb-2">
              <div className="">
                {msg.support ? (
                  <span className="fs-5 fw-bolder text-gray-900 me-1">
                    Support
                  </span>
                ) : (
                  <a
                    href={`/p2c/customers/${ticket.user._id}/overview`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {ticket.user.username}
                  </a>
                )}
                <span className="text-muted fs-7 mb-1">
                  {formatDate(intl, msg.date)}
                </span>
              </div>
            </div>
            <div className={clsx(
              'p-5 rounded text-gray-900 fw-bold mw-lg-400px text-start',
              msg.support ? 'bg-light-primary' : 'bg-light-info'
            )}>
              {msg.content}
            </div>
          </div>
        </div>
      ))}

      <div className='separator separator-dashed my-5'></div> 
      <ReplyForm />
    </>
  );
}
